import React, { useEffect } from 'react';
import { useSetLastVisitedMutation } from 'API/order/VisitTrackingAPI';
import { DateTime } from 'luxon';
import { useGetMostRecentQuery, useSetMostRecentMutation } from 'API/order/PinnedAndRecentAPI';

export interface ITrackOrderVisitProps {
  fileNumber?: string | null;
}

const moveOrderToFront = (values: string[], order: string) => {
  const newValues = values.filter((t) => t !== order);
  newValues.unshift(order);
  return newValues;
};

export const TrackOrderVisit: React.FC<ITrackOrderVisitProps> = ({ fileNumber }) => {
  const { data: orders = [], isLoading } = useGetMostRecentQuery();
  const [setMostRecent] = useSetMostRecentMutation();
  const [setLastVisited] = useSetLastVisitedMutation();

  useEffect(() => {
    if (fileNumber && !isLoading) {
      if (orders[0] !== fileNumber) {
        setMostRecent(moveOrderToFront(orders, fileNumber));
        setLastVisited({ id: fileNumber, body: DateTime.now().toISO() });
      }
    }
  }, [fileNumber, orders, isLoading, setLastVisited, setMostRecent]);
  return <></>;
};
